import React from 'react';

interface AwardBadgeSvgProps {
	label: string;
	children: React.ReactNode;
}

export const AwardBadgeSvg = ({ label, children }: AwardBadgeSvgProps) => (
	<svg
		viewBox="0 0 100 100"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		role="img"
		focusable={false}
		aria-label={label}
	>
		<title>{label}</title>
		{children}
	</svg>
);
